<template>
	<div class="qingwu">
		<div class="admin_main_block">
			<div class="admin_main_block_top">
				<div class="admin_main_block_left">
					<!-- <div><router-link to="/Admin/withdrawal/userlogform"><el-button type="primary" icon="el-icon-plus">添加</el-button></router-link></div> -->
					<div><el-input v-model="phone" placeholder="请输入用户手机号码"></el-input></div>
					<div><el-input v-model="F_VR_NIC" placeholder="请输入用户昵称"></el-input></div>
					<div><el-input v-model="user_id" placeholder="请输入用户ID"></el-input></div>
					<div><el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" v-model="times" type="datetimerange"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker></div>
					
					<div><el-button icon="el-icon-search" @click="get_cash_list">条件筛选</el-button></div>
				</div>

				<!-- <div class="admin_main_block_right">
                    <div><el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button></div>
                </div> -->
			</div>

			<div class="admin_table_main">
				<el-table :data="list" @selection-change="handleSelectionChange" @sort-change="sortChange">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column>
					<!-- <el-table-column prop="networkName" label="广告平台"></el-table-column> -->
					<el-table-column prop="networkPlacementId" label="广告ID" width="120px"></el-table-column>
					<el-table-column prop="Ecpm" label="Ecpm广告价值" width="120px"></el-table-column>
					<el-table-column sortable="custom" prop="price" label="用户收益" width="100px">
						<template slot-scope="scope">
							<span>{{scope.row.price||'0'}}金币</span>
						</template>
					</el-table-column>
					<el-table-column prop="user" label="用户信息" width="160px">
						<template slot-scope="scope">
							<div v-if="scope.row.user">
								<div class="table-row">
									<span>用户头像：</span>
									<el-avatar shape="circle" :size="30" :src="scope.row.user.F_VR_TOUX"></el-avatar>
								</div>
								<div class="table-row">
									<span>用户昵称：</span>
									<span>{{scope.row.user.F_VR_NIC}}</span>
								</div>
								<div class="table-row">
									<span>用户ID：</span>
									<span>{{scope.row.user.id}}</span>
								</div>
								<div class="table-row">
									<span>手机号码：</span>
									<span>{{scope.row.user.phone}}</span>
								</div>
							</div>
							<span v-else>
								账号不存在(删除/注销)
							</span>
						</template>
					</el-table-column>
					<el-table-column label="设备信息">
						<template slot-scope="scope">
							手机品牌：{{scope.row.brand}}
							<br>
							手机型号：{{scope.row.brand_model}}
							<br>
							设备ID：{{scope.row.device_id}}
						</template>
					</el-table-column>
					<!-- <el-table-column prop="brand" label="手机品牌"></el-table-column>
					<el-table-column prop="brand_model" label="手机型号"></el-table-column>
					<el-table-column prop="device_id" label="设备ID"></el-table-column> -->
					<el-table-column prop="ip" label="IP" width="100px"></el-table-column>
					
					<el-table-column prop="add_time" label="观看时间"></el-table-column>
				</el-table>
				<div class="admin_table_main_pagination">
					<el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total"
						:total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				phone: '',
				user_id:'',
				F_VR_NIC:'',
				list: [],
				total_data: 0, // 总条数
				page_size: 20,
				current_page: 1,
				select_id: '',
				sort:'',
				direction:'',
				times: '',
			};
		},
		watch: {},
		computed: {},
		methods: {
			sortChange(e){
				let order='desc'
				if(e.order=='ascending'){
					order='asc'
				}
				if(e.order=='descending'){
					order='desc'
				}
				this.current_page=1
				this.sort=e.prop
				this.direction=order
				this.get_cash_list()
			},
			handleSelectionChange: function(e) {
				let ids = [];
				e.forEach(v => {
					ids.push(v.id);
				});
				this.select_id = ids.join(',');
			},
			get_cash_list: function() {
				let _this = this;
				this.$get(this.$api.ecmpIndex, {
					page: this.current_page,
					phone: this.phone,
					user_id: this.user_id,
					F_VR_NIC: this.F_VR_NIC,
					sort:this.sort,
					direction:this.direction,
					add_time:JSON.stringify(this.times)
				}).then(function(res) {
					_this.page_size = res.data.per_page;
					_this.total_data = res.data.total;
					_this.current_page = res.data.current_page;
					_this.list = res.data.data;
				})

			},
			// 分页改变
			current_change: function(e) {
				this.current_page = e;
				this.get_cash_list();
			},
			// 删除处理
			// del:function(id){
			//     let _this = this;
			//     if(this.$isEmpty(id)){
			//         return this.$message.error('请先选择删除的对象');
			//     }
			//     this.$post(this.$api.withdrawalDel,{id:id}).then(function(res){
			//         if(res.code == 200){
			//             _this.get_cash_list();
			//             return _this.$message.success("删除成功");
			//         }else{
			//             return _this.$message.error("删除失败");
			//         }
			//     });
			// },
		},
		created() {
			this.get_cash_list();
		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>
.table-row{
	display: flex;
	flex-direction: row;
	align-items: center;
}
</style>